import React from "react";

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-[#00ff87] mb-3">
    <span className="h-px w-6 bg-[#00ff87]" />
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, highlight, subtitle, center = true }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-12`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-white">
      {title} {highlight && <span className="neon-green text-glow-green">{highlight}</span>}
    </h2>
    {subtitle && (
      <p className="mt-4 text-gray-400 text-base sm:text-lg leading-relaxed">{subtitle}</p>
    )}
  </div>
);
